import Script from "next/script";
import H2 from "@/atoms/text/H2";
import { useEffect, useRef, useState } from "react";

const Trustpilot = ({ title, color, theme, className, variant }) => {
  const tpElement = useRef(null);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (!isScriptLoaded) {
      setIsScriptLoaded(true);
    }
  }, [isScriptLoaded]);

  const initializeTrustpilotWidget = () => {
    if (tpElement.current && window.Trustpilot) {
      // Re-initialize Trustpilot widget after it has loaded
      window.Trustpilot.loadFromElement(tpElement.current);
    }
  };

  useEffect(() => {
    if (isScriptLoaded) {
      initializeTrustpilotWidget();
    }
  }, [isScriptLoaded]);

  const renderCarousel = (
    <section className={`pv-15-d pv-8 ${className}`}>
      <div className="container ta-center">
        {title && (
          <H2
            color={color}
            className="mb-8-d mb-6 bold"
            dangerouslySetInnerHTML={{
              __html: `${title}<span class="dot">.</span>`,
            }}
          ></H2>
        )}
        {/* TrustBox widget - Slider */}
        <div
          ref={tpElement}
          className="trustpilot-widget carousel"
          data-locale="en-US"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="51f84db800006400056d1a9b"
          data-style-height="140px"
          data-style-width="100%"
          data-theme={theme}
          data-text-color="#33393D"
          data-stars="5"
          data-review-languages="en"
        >
          <a
            href="https://www.trustpilot.com/review/answerforce.com"
            target="_blank"
            rel="noopener"
          >
            Trustpilot
          </a>
        </div>
        {/* End TrustBox widget */}
      </div>
    </section>
  );

  const renderMini = (
    <div
      ref={tpElement}
      className="trustpilot-widget mini"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="51f84db800006400056d1a9b"
      data-style-height="120px"
      data-theme="dark"
    >
      <a
        href="https://www.trustpilot.com/review/answerforce.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
      <style jsx>{`
        .trustpilot-widget.mini {
          width: 235px;
          height: 120px;
        }
        .trustpilot-widget.mini {
          transform: scale(0.6);
          transform-origin: -30px;
        }
      `}</style>
    </div>
  );

  return (
    <>
      {variant === "carousel" && renderCarousel}
      {variant === "mini" && renderMini}

      {/* Load script once when either variant is selected */}
      {isScriptLoaded && (
        <Script
          src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
          onLoad={initializeTrustpilotWidget} // Re-initialize Trustpilot when script loads
        />
      )}
    </>
  );
};

Trustpilot.defaultProps = {
  className: "bc-blue-light",
  color: "black",
  theme: "light",
};

export default Trustpilot;
